import { useQuery } from 'react-query';
import { useApi } from '../../../core/api/api.context';
import { QueryKeys } from '../../../core/queries/query-keys.constants';
import { HistoricalUtilisationQueryDto } from '@groundfloor-platform/mgmt-service-g-sdk';

export function useQueryLockerUtilisationReport(
  projectID: string,
  { groupBy, fromDate, toDate, hubID }: HistoricalUtilisationQueryDto
) {
  const api = useApi();

  return useQuery(
    [QueryKeys.REPORTS, QueryKeys.LOCKER_UTILISATION, projectID, groupBy, fromDate, toDate, hubID],
    async () => {
      return await api.statsController.historicalDeliveryContainerUtilisation(groupBy, toDate, {
        fromDate,
        hubID,
        projectID,
        includeChildProjects: true
      });
    }
  );
}
